import * as moment from 'moment';

export class CommonSchedule {
    routeId: number;
    isReverseTrip: boolean;
    dayType: number;
    startTime: Date;
    endTime: Date;
    interval: number;
}

export class Schedule {
    id: string;
    routeId: number;
    isReverseTrip: boolean;
    dayType: number;
    stopSchedules: StopSchedule[];
}

export class StopSchedule {
    stopId: number;
    arrivalTime: Date;
    departureTime: Date;
}

export class StopCommonSchedule {
    stopId: number;
    routeId: number;
    isReverseRoute: boolean;
    dayType: number;
    departureTimes: Date[];
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/schedule.ts